import React, { useContext, useEffect, useState } from "react";

import { storageLocal as storage } from "../../../../utils/StorageHandler";
import CalculatorHeader from "../../../shared/CalculatorHeader";
import CalculatorInactiveText from "../../../shared/CalculatorInactiveText";
import Container from "../../../shared/Container";
import { PageContext } from "../../../shared/Page";
import useSnackbar from "../../../shared/Snackbar/store";
import Calculator from "./Calculator";
import CalculatorResult from "./CalculatorResult";
import useCalculatorStore from "./store";

const CalculatorPage = ({ isWebview, isActive = true, inactiveText = "" }) => {
    const pageContext = useContext(PageContext);
    const { updateLastCalculator } = pageContext.actions;
    const { notify } = useSnackbar();
    const calculated = storage.get("hel:calculated", false);

    const [
        result,
        loading,
        shouldCalculate,
        setShouldCalculate,
        zipcode,
        amount,
        up,
        calculate,
        initialLoadingFinished,
    ] = useCalculatorStore((state) => [
        state.result,
        state.loading,
        state.shouldCalculate,
        state.setShouldCalculate,
        state.zipcode,
        state.amount,
        state.up,
        state.calculate,
        state.initialLoadingFinished,
    ]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setShouldCalculate(true);
        if (calculated) {
            const element = document.getElementById("element-img-shape");
            if (element) {
                element.remove(); // Entfernt das Element direkt aus dem DOM
            }
        }
    }, []);

    useEffect(() => {
        if (shouldCalculate && zipcode && amount && up) {
            updateLastCalculator("heizoel");
            calculate(zipcode, amount, up, notify);
        }
    }, [zipcode, shouldCalculate, amount, up, calculate]);

    const [calculatorVisible, setCalculatorVisible] = useState(true);

    useEffect(() => {
        if (!loading && initialLoadingFinished) {
            if (result.length === 0) {
                setCalculatorVisible(true);
            } else {
                setCalculatorVisible(false);
            }
        }
    }, [loading, result, initialLoadingFinished]);

    return isActive ? (
        <Container>
            <CalculatorHeader
                isWebview={isWebview}
                headline="Heizöl"
                hideChangeData={calculatorVisible}
                onClickChangeData={() => setCalculatorVisible(true)}
            />
            {calculatorVisible && <Calculator isLoading={loading} />}
            <CalculatorResult />
        </Container>
    ) : (
        inactiveText && (
            <CalculatorInactiveText>{inactiveText}</CalculatorInactiveText>
        )
    );
};

export default CalculatorPage;
